export default __webpack_public_path__ + "f8f0d110d72a3f9b421fb2ef280695d0.svg";